import z from "zod";

export const profilerToolbarDataSchema = z.object({
  token: z
    .string()
    .optional()
    .transform((value) => value || undefined)
    .describe(
      "Profile token, as the X-Debug-Token header carries it; absent when the request was not collected.",
    ),
  traceId: z
    .string()
    .optional()
    .transform((value) => value || undefined)
    .describe("OpenTelemetry trace id of the request, when it had one."),
});

export type ProfilerToolbarDataProps = z.infer<
  typeof profilerToolbarDataSchema
>;
